import React from "react";
import "./AbsoluteBg.css";

const AbsoluteBg = () => {
  return (
    <div className="absolute-bg-container">
      {/* Left Image */}
      <img src="/bg-graphic.png" alt="background graphic left" className="bg-graphic left-graphic" />

      {/* Right Image */}
      <img src="/bg-graphic.png" alt="background graphic right" className="bg-graphic right-graphic" />
    </div>
  );
};

export default AbsoluteBg;
